import React from 'react';
import Container from "./Container";
import Asset from "./Asset";
import classNames from "classnames";

const AssetGroup = ({ group, selectedAsset, hoveredAsset, onSelectAsset, onHoverAsset, containsGroups }) => {
  const hoverableGroup = !group.pseudo

  return (
    <Container
      className={classNames(
        'asset-group',
        {
          'text-muted': group.decommissioned,
          'has-link': group.link != null,
          'selected': group == selectedAsset,
          'vdc-hovered': group === hoveredAsset,
        }
      )}
      group={group}
      icon={group.decommissioned ? 'fa-ban' : group.icon}
      title={group.name}
      onSelectAsset={onSelectAsset}
      onMouseEnter={hoverableGroup ? () => onHoverAsset(group) : null}
      onMouseLeave={hoverableGroup ? () => onHoverAsset(null) : null}
      startsExpanded={containsGroups}
    >
      {
        (containsGroups) ?
          <div className='asset-group-listing'>
            {
              group.assetGroups.map(
                nestedGroup => (
                  <AssetGroup
                    key={nestedGroup.id}
                    group={nestedGroup}
                    selectedAsset={selectedAsset}
                    hoveredAsset={hoveredAsset}
                    onSelectAsset={onSelectAsset}
                    onHoverAsset={onHoverAsset}
                    containsGroups={nestedGroup.assetGroups && nestedGroup.assetGroups.length > 0}
                  />
                )
              )
            }
          </div>
          : null
      }
      {
        (group.assets && group.assets.length) ?
          <div className='asset-listing'>
            {
              group.assets.map(
                asset => (
                  <Asset
                    key={asset.id}
                    asset={asset}
                    selectedAsset={selectedAsset}
                    hoveredAsset={hoveredAsset}
                    onSelectAsset={onSelectAsset}
                    onHoverAsset={onHoverAsset}
                  />
                )
              )
            }
          </div>
          : null
      }
    </Container>
  )
};

export default AssetGroup;
